module.exports = __webpack_public_path__ + "img/video-temp.9db0cfbb.jpg";